import React, { useState } from 'react';

const HomePage: React.FC = () => {
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [showConstraintsPopup, setShowConstraintsPopup] = useState(false);

  const scrollToServices = () => {
    document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="home-page">
      <section className="hero">
        <h1>AUTOMATED DATA REFINEMENT & ENHANCEMENT</h1>
        <p>Data handling made simple</p>
        <button onClick={scrollToServices} className="view-services-button">VIEW SERVICES</button>
      </section>

      <section className="services" id="services-section">
        <h2>EFFORTLESS DATA CLEANING</h2>
        <p>Transform your data with ease.</p>
        <div className="service-grid">
          <div className="service-card">
            <h3>Data cleaning</h3>
            <p>Effortlessly clean your datasets to ensure accuracy.</p>
            <a href="/data-cleaning" className="view-services-button">Get Started</a>
          </div>
          <div className="service-card">
            <h3>Data preprocessing</h3>
            <p>Prepare your data for optimal analysis quickly.</p>
            <a href="/preprocessing" className="view-services-button">Get Started</a>
          </div>
          
          <div className="service-card">
            <h3>Data visualization</h3>
            <p>Transform your data into insightful visuals effortlessly.</p>
            <a href="/data-cleaning" className="view-services-button">Get Started</a>
          </div>
        </div>
      </section>

      <section className="additional-info">
        <div className='additional-info-feature'>
          {/* image here */}
          <h2>Upload your data</h2>
          <p>Easily upload your files to start your data handling process.</p>
          <button onClick={() => setShowUploadPopup(true)} className="learn-more-button">Learn more</button>
        </div>
        <div className='additional-info-feature'>
          {/* image here */}
          <h2>Define constraints</h2>
          <p>Set precise constraints to refine your data for optimal results.</p>
          <button onClick={() => setShowConstraintsPopup(true)} className="learn-more-button">Learn more</button>
        </div>
      </section>

      {showUploadPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className='popup-content-section'>
              <div className='popup-img-container'>
                <img className='popup-img' src="/data-upload.png" alt="Upload your data" />
              </div>
              
            </div>
            <div className='popup-content-section'>
              <h2>Upload your data</h2>
              <p>
                Begin your autonomous data preparation journey by uploading your CSV or Excel files, more formats will be supported soon. 
                Preview your data before and after modifications to ensure accuracy and enhance analysis. 
                Your data security and privacy are top priorities; all data is processed locally and only saved on your device when you download the results.
              </p>
              <button onClick={() => setShowUploadPopup(false)} className="close-popup-button">Close</button>
            </div>
          </div>
        </div>
      )}

      {showConstraintsPopup && (
        <div className="popup-overlay">
          
          <div className="popup-content">
            <div className='popup-content-section'>
              <div className='popup-img-container'>
                <img className='popup-img' src="data-tuning.png" alt="Define Constraints" />
              </div>
            </div>
            <div className='popup-content-section'>
              <h2>Define constraints</h2>
              <p>
                You have the power to define specific constraints that align
                with your project requirements. By fine-tuning
                parameters, you enhance the efficiency and effectiveness of the process. This
                platform also gives you
                clear insight before finalizing your decisions. Take advantage of this feature to elevate the
                quality of your data significantly. Should you decide not to set any constraints, 
                the system will apply essential modifications to optimize the data for training or analysis, 
                so you don't have to.
              </p>
              <button onClick={() => setShowConstraintsPopup(false)} className="close-popup-button">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;